module.exports = __webpack_public_path__ + "images/72d5f6b92b57c8aeae1fbff140fa7663d782d83a3593abe1b069bb06ef6e01de.svg";